import request from 'assets/js/http';
export const queryFeishuGroupList = data => {
  return request({
    url: '/companyGroup/queryFeishuGroupList',
    method: 'post',
    data: data
  });
};
export const bindFeishuGroup = data => {
  return request({
    url: '/companyGroup/bindFeishuGroup',
    method: 'post',
    data: data
  });
};
export const unbindFeishuGroup = data => {
  return request({
    url: '/companyGroup/unBindFeishuGroup',
    method: 'post',
    data: data
  });
};
export const feishuSourceList = data => {
  return request({
    url: '/companyGroup/feishuSourceList',
    method: 'post',
    data: data
  });
};

export const feishuGroupFileList = data => {
  return request({
    url: '/feishuResources/queryGroupFileListByGroupId',

    method: 'post',
    data: data
  });
};

export const viewResources = data => {
  return request({
    url: '/feishuResources/viewResources',
    method: 'post',
    data: data
  });
};
